import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 81,
	viewBox: "0 0 80 81",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: .75,
		width: 80,
		height: 80,
		rx: 40,
		fill: "#F7F7F7"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M43.9993 50.0833C43.9993 51.4891 42.9115 52.6409 41.5317 52.7426L41.3327 52.75H38.666C37.2602 52.75 36.1085 51.6622 36.0067 50.2823L35.9993 50.0833H43.9993ZM39.9996 27.4166C45.0469 27.4166 49.1584 31.423 49.3275 36.4291L49.3329 36.75V41.7685L51.7623 46.6274C52.2267 47.5562 51.6056 48.6411 50.6036 48.7423L50.4505 48.75H29.5486C28.5103 48.75 27.8176 47.7093 28.1752 46.7678L28.2368 46.6274L30.6662 41.7685V36.75C30.6662 31.5953 34.8449 27.4166 39.9996 27.4166ZM39.9996 30.0833C36.4146 30.0833 33.4905 32.913 33.3391 36.4608L33.3329 36.75V41.7685C33.3329 42.0997 33.2712 42.4272 33.1517 42.7346L33.0514 42.9612L31.4903 46.0833H48.5088L46.9477 42.9612C46.7997 42.6648 46.7084 42.3443 46.6778 42.0159L46.6663 41.7685V36.75C46.6663 33.0681 43.6815 30.0833 39.9996 30.0833Z",
		fill: "#8C8C8C"
	})]
});
export default SvgBellCircle;
